module.exports = __webpack_public_path__ + "993316985fdd16b5019cd64f866afcb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = 226
// module chunks = 0